// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'euclid', 'euclid Fallback'"},"className":"__className_f8c71a","variable":"__variable_f8c71a"};